export default "__VITE_ASSET__BZ1krvEV__"